<template>
  <div class="exam-uniform-student-score-pass-line"
       v-loading="loading">
    <template v-if="passLine">
      <template v-if="passLine.items && passLine.items.length">
        <div class="body"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <div class="form-wrap">
            <el-form size="mini"
                     label-width="150px"
                     label-suffix="：">
              <el-form-item v-for="item in passLine.items"
                            :key="item.id"
                            :label="item.name">
                <el-input-number v-model.number="item.passScore"
                                 controls-position="right"
                                 :min="0"
                                 :step="1"
                                 :precision="0"></el-input-number>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="footer">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">提交保存</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">关闭窗口</el-button>
        </div>
      </template>
      <template v-else>
        <Hint>
          <span>未安排统考科目</span>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>分数线配置加载失败</div>
        <el-button type="text"
                   @click="loadPassLine">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'ExamUniformStudentScorePassLine',
  components: {
    Hint
  },
  props: {
    extraParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      passLine: null,
      committing: false
    }
  },
  methods: {
    loadPassLine () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/exam/uniform/student/score/passLine',
        method: 'post',
        data: this.$qs.stringify(this.extraParams)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.passLine = response.data['passLine'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      const passLine = this.passLine
      if (passLine) {
        const items = passLine.items
        if (items && items.length) {
          let isValid = items.every(item => {
            if (typeof item.passScore !== 'number') {
              this.$message.warning(`科目“${item.name}”分数线未设置`)
              return
            }
            return true
          })
          if (!isValid) {
            return
          }
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/exam/uniform/student/score/savePassLine',
            method: 'post',
            data: this.$qs.stringify(this.$extend({
              passLine: JSON.stringify(passLine)
            }, this.extraParams))
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  this.$nextTick(() => {
                    this.$emit('hidePopoverAndRefresh')
                  })
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }
      }
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadPassLine()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadPassLine()
      }
    }
  }
}
</script>

<style lang="scss">
  .exam-uniform-student-score-pass-line {
    min-height: 140px;
    display: flex;
    flex-direction: column;
    & > .body {
      flex: auto;
      & > .form-wrap {
        padding: 20px 30px;
        .el-form {
          .el-form-item {
            &:last-child {
              margin-bottom: 0;
            }
            .el-form-item__label {
              font-size: 12px;
            }
            .el-form-item__content {
              .el-input-number {
                width: 100px;
                .el-input__inner {
                  padding-left: 10px;
                  padding-right: 35px;
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
    .layout-hint {
      height: 140px;
    }
  }
</style>
